module.exports = __webpack_public_path__ + "static-portal/img/logo1.1ff68f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 4